export default __webpack_public_path__ + "static/media/visa.b028a092.svg";